import {StorageWrapper} from './StorageWrapper'
import {Howler, Howl} from 'howler'
import {UIImagePathController} from './UIEnums.ts'
import {ArrayUtils} from '../../../shared/utils/ArrayUtils'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables'
import {UIAppState} from './UIAppState'

export module Sound {
    export const DEFAULT_VOLUME = 0.5
    export const DELAY_FOR_NATURAL_EFFECT = 500
    export interface SoundItem {
        groupType: SoundGroupType
        soundType: SoundType
        fileName: string
    }

    export enum SoundGroupType {
        SFX,
        MUSIC
    }

    export enum SoundType {
        DiceRoll1, DiceRoll2, DiceRoll3, DiceRoll4, YourTurn, FirstReminder, SecondReminder,
        RoadPlace, SettlementPlace, CityPlace, ShipPlace, ShipMove, MetropolisPlace, CityWallPlace, CityDestroy, CityImprovement,
        RobberPlace, PiratePlace,
        LeaveRoom, JoinRoom, RoomSettingUpdated, RoomGetReady,
        ClockTick, MessageNotification, Click, Victory, Wedding, VoteReminder, AchievementCKProgress, GameStarted, AchievementLargestArmy, AchievementLongestRoad, SettlementPhaseEnded,
        OfferAcceptable, OfferNotAcceptable, OfferAccepted, OfferRejected, Reconnect, Disconnect, KnightEquip, KnightPlace, KnightUpgrade, DiscardBroadcast, DiscardNotification, MusicBeautifulNewDawn, MusicEgoSum, MusicGameOfMonarchies, MusicGrudgeAndBetrayal, MusicJanissarysDream, MusicNoRegrets,
        BeginnerHintActivated, DevelopmentCardBought, DevelopmentCardMonopoly, DevelopmentCardUsed
    }

    export const allowedMobileBackgroundSounds: SoundType[] = [
        SoundType.YourTurn,
        SoundType.JoinRoom,
        SoundType.LeaveRoom,
        SoundType.GameStarted,
    ]

    export const allSounds: SoundItem[] = [
        {
            soundType: SoundType.DiceRoll1,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_dice_roll_1.mp3',
        },
        {
            soundType: SoundType.DiceRoll2,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_dice_roll_2.mp3',
        },
        {
            soundType: SoundType.DiceRoll3,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_dice_roll_3.mp3',
        },
        {
            soundType: SoundType.DiceRoll4,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_dice_roll_4.mp3',
        },
        {
            soundType: SoundType.YourTurn,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_your_turn.mp3',
        },
        {
            soundType: SoundType.FirstReminder,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_first_reminder.mp3',
        },
        {
            soundType: SoundType.RoadPlace,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_road_place.mp3',
        },
        {
            soundType: SoundType.SettlementPlace,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_settlement_place.mp3',
        },
        {
            soundType: SoundType.CityPlace,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_city_place.mp3',
        },
        {
            soundType: SoundType.ShipPlace,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_ship_place.mp3',
        },
        {
            soundType: SoundType.ShipMove,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_ship_move.mp3',
        },
        {
            soundType: SoundType.MetropolisPlace,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_metropolis_place.mp3',
        },
        {
            soundType: SoundType.CityWallPlace,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_city_wall_place.mp3',
        },
        {
            soundType: SoundType.CityDestroy,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_city_destroy.mp3',
        },
        {
            soundType: SoundType.CityImprovement,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_city_improvement.mp3',
        },
        {
            soundType: SoundType.RobberPlace,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_robber_place.mp3',
        },
        {
            soundType: SoundType.PiratePlace,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_pirate_place.mp3',
        },
        {
            soundType: SoundType.VoteReminder,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_vote_reminder.mp3',
        },
        {
            soundType: SoundType.OfferAcceptable,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_offer_acceptable.mp3',
        },
        {
            soundType: SoundType.OfferNotAcceptable,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_offer_not_acceptable.mp3',
        },
        {
            soundType: SoundType.OfferAccepted,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_offer_accepted.mp3',
        },
        {
            soundType: SoundType.OfferRejected,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_offer_rejected.mp3',
        },
        {
            soundType: SoundType.ClockTick,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_clock_tick.mp3',
        },
        {
            soundType: SoundType.KnightEquip,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_knight_equip.mp3',
        },
        {
            soundType: SoundType.KnightPlace,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_knight_place.mp3',
        },
        {
            soundType: SoundType.KnightUpgrade,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_knight_upgrade.mp3',
        },
        {
            soundType: SoundType.DiscardBroadcast,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_discard_broadcast.mp3',
        },
        {
            soundType: SoundType.DiscardNotification,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_discard_notification.mp3',
        },
        {
            soundType: SoundType.Click,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_click.mp3',
        },
        {
            soundType: SoundType.MessageNotification,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_message_notification.mp3',
        },
        {
            soundType: SoundType.JoinRoom,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_join_room.mp3',
        },
        {
            soundType: SoundType.LeaveRoom,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_leave_room.mp3',
        },
        {
            soundType: SoundType.RoomSettingUpdated,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_room_setting_updated.mp3',
        },
        {
            soundType: SoundType.RoomGetReady,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_room_get_ready.mp3',
        },
        {
            soundType: SoundType.AchievementCKProgress,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_achievement_ck_progress.mp3',
        },
        {
            soundType: SoundType.AchievementLargestArmy,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_achievement_largest_army.mp3',
        },
        {
            soundType: SoundType.AchievementLongestRoad,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_achievement_longest_road.mp3',
        },
        {
            soundType: SoundType.GameStarted,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_game_started.mp3',
        },
        {
            soundType: SoundType.SettlementPhaseEnded,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_settlement_phase_ended.mp3',
        },
        {
            soundType: SoundType.Victory,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_victory.mp3',
        },
        {
            soundType: SoundType.Reconnect,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_reconnect.mp3',
        },
        {
            soundType: SoundType.Disconnect,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_disconnect.mp3',
        },
        {
            soundType: SoundType.BeginnerHintActivated,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_beginner_hint_activated.mp3',
        },
        {
            soundType: SoundType.DevelopmentCardBought,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_devcard_bought.mp3',
        },
        {
            soundType: SoundType.DevelopmentCardUsed,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_devcard_used.mp3',
        },
        {
            soundType: SoundType.DevelopmentCardMonopoly,
            groupType: SoundGroupType.SFX,
            fileName: 'sfx_devcard_monopoly.mp3',
        },
        // {
        //     soundType: SoundType.MusicNoRegrets,
        //     groupType: SoundGroupType.MUSIC,
        //     fileName: 'music_no_regrets.mp3',
        // },
        // {
        //     soundType: SoundType.MusicBeautifulNewDawn,
        //     groupType: SoundGroupType.MUSIC,
        //     fileName: 'music_beautiful_new_dawn.mp3',
        // },
        // {
        //     soundType: SoundType.MusicGrudgeAndBetrayal,
        //     groupType: SoundGroupType.MUSIC,
        //     fileName: 'music_grudge_and_betrayal.mp3',
        // },
        // {
        //     soundType: SoundType.MusicJanissarysDream,
        //     groupType: SoundGroupType.MUSIC,
        //     fileName: 'music_janissarys_dream.mp3',
        // },
        // {
        //     soundType: SoundType.MusicGameOfMonarchies,
        //     groupType: SoundGroupType.MUSIC,
        //     fileName: 'music_game_of_monarchies.mp3',
        // },
        // {
        //     soundType: SoundType.MusicEgoSum,
        //     groupType: SoundGroupType.MUSIC,
        //     fileName: 'music_ego_sum.mp3',
        // },
    ]

    let muted = false
    let currentMusicHowl: Howl
    let allSoundObjects: Howl[] = []

    export function loadSounds() {
        const volume = StorageWrapper.getMasterVolume(DEFAULT_VOLUME)
        setMasterVolume(volume)

        allSoundObjects = allSounds.map((item: SoundItem) => new Howl({
            src: UIImagePathController.getSoundPath(item.fileName, UIUtilsEjsVariables.isUserOnDiscord),
        }))

        if(UIUtilsEjsVariables.isUserOnMobileApp || UIUtilsEjsVariables.isUserOnDiscordMobile) handleSoundContextLossForIOSMobile()
    }

    export function setMasterVolume(newVolume: number) {
        Howler.volume(newVolume)
        StorageWrapper.setMasterVolume(newVolume)
        muted = newVolume === 0
    }

    export function setMusicVolume(newVolume: number) {
        StorageWrapper.setMusicVolume(newVolume)
        if(currentMusicHowl == undefined) return
        const musicPlaybackVolume = calculateVolume(SoundGroupType.MUSIC)
        currentMusicHowl.volume(musicPlaybackVolume)
    }

    export function playSound(sound: SoundType, relativeVolume?: number | undefined, pitch?: number | undefined) {
        if(muted) return
        if(!canPlaySoundInMobile(sound)) return

        const soundIndex = getSoundIndexFromType(sound)
        if(soundIndex < 0) return
        const soundObject = allSoundObjects[soundIndex]
        if(soundObject == undefined) return

        checkAndResumeHowlerContext()

        const soundGroupType = allSounds[soundIndex].groupType
        const volume = calculateVolume(soundGroupType, relativeVolume)
        soundObject.volume(volume)

        const soundId = soundObject.play()
        pitch ??= 1
        soundObject.rate(isFinite(pitch) ? pitch : 1, soundId)
    }

    export function getSoundIndexFromType(soundType: SoundType): number {
        return allSounds.findIndex((sound: SoundItem) => sound.soundType == soundType)
    }

    export function calculateVolume(soundGroupType: SoundGroupType, relativeVolume?: number | undefined): number {
        const inputVolume = (relativeVolume ?? 1)
        const masterVolume = StorageWrapper.getMasterVolume(DEFAULT_VOLUME)
        let soundTypeVolume = DEFAULT_VOLUME
        switch(soundGroupType) {
            case SoundGroupType.MUSIC:
                soundTypeVolume = StorageWrapper.getMusicVolume(DEFAULT_VOLUME)
                break
            case SoundGroupType.SFX:
            default:
                break
        }
        return inputVolume * masterVolume * soundTypeVolume
    }

    export function toggleSound() {
        muted = !muted
        setMasterVolume(muted ? 0 : DEFAULT_VOLUME)
    }

    export function getMuted(): boolean {
        return muted
    }

    export function playMusic() {
        const musicSounds = allSounds.filter((soundItem: SoundItem) => soundItem.groupType == SoundGroupType.MUSIC && soundItem.soundType != SoundType.MusicEgoSum) // filter out music for end game screen
        const shuffledMusicSounds = ArrayUtils.shuffle(musicSounds)

        loopMusic(0, shuffledMusicSounds)
    }

    export function loopMusic(index: number, musicSounds: SoundItem[]) {
        const newHowl = new Howl({
            src: [UIImagePathController.getSoundPath(musicSounds[index].fileName, UIUtilsEjsVariables.isUserOnDiscord)],
            preload: true,
            onend: () => {
                if((index + 1) == musicSounds.length) {
                    loopMusic(0, musicSounds)
                } else {
                    loopMusic(index + 1, musicSounds)
                }
            },
            volume: calculateVolume(SoundGroupType.MUSIC),
        })
        currentMusicHowl = newHowl
        currentMusicHowl.play()
    }

    export function stopMusic() {
        currentMusicHowl.stop()
    }

    export function canPlaySoundInMobile(sound: SoundType) {
        if(!UIUtilsEjsVariables.isUserOnMobileApp) return true
        if(UIAppState.isAppRunningOnBackground == false) return true
        if(allowedMobileBackgroundSounds.includes(sound)) return true

        return false
    }

    export function checkAndResumeHowlerContext() {
        if(!UIUtilsEjsVariables.isUserOnMobile) return

        const context = Howler.ctx
        if(context.state == 'suspended') void context.resume()
    }
}

function handleSoundContextLossForIOSMobile() {
    document.addEventListener('visibilitychange', () => {
        const {ctx} = Howler
        if(document.visibilityState !== 'hidden') {
            setTimeout(async() => {
                await ctx?.resume()
            }, 500)
        }
    }, false)
}
